import { useState } from 'react';

export interface Letter {
  key: string;
  color: 'grey' | 'green' | 'yellow';
}

const useWordle = (solution: string) => {
  const [turn, setTurn] = useState<number>(0);
  const [currentGuess, setCurrentGuess] = useState<string>('');
  const [guesses, setGuesses] = useState<Letter[][]>([...Array(6)]);
  const [history, setHistory] = useState<Array<string>>([]);
  const [isCorrect, setIsCorrect] = useState<boolean>(false);

  // Remove accent
  function removeAccents(str: string): string {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  // Gestion de la couleur
  const formatGuess = (): Letter[] => {
    let solutionArray = removeAccents(solution.toLowerCase()).split('');
    let formattedGuess: Letter[] = currentGuess
      .toLowerCase()
      .split('')
      .map((letter) => {
        return { key: letter, color: 'grey' };
      });

    //GOOD letter RIGHT place (i = index & l = letter)
    formattedGuess.forEach((l, i) => {
      if (solutionArray[i] === l.key) {
        formattedGuess[i].color = 'green';
        solutionArray[i] = '';
      }
    });

    //GOOD letter WRONG place
    formattedGuess.forEach((l, i) => {
      if (solutionArray.includes(l.key) && l.color !== 'green') {
        formattedGuess[i].color = 'yellow';
        solutionArray[solutionArray.indexOf(l.key)] = '';
      }
    });
    console.error('formattedGuess', formattedGuess);
    return formattedGuess;
  };

  const addNewGuess = (formattedGuess: Letter[]) => {
    if (currentGuess.toLowerCase() === solution.toLowerCase()) {
      setIsCorrect(true);
    }
    setGuesses((prevGuesses) => {
      let newGuesses = [...prevGuesses];
      newGuesses[turn] = formattedGuess;
      return newGuesses;
    });
    setHistory((prevHistory) => {
      return [...prevHistory, currentGuess];
    });
    setTurn((prevTurn) => {
      return prevTurn + 1;
    });

    setCurrentGuess('');
  };

  const handleKeyup = ({ key }: { key: string }) => {
    if (key === 'Enter') {
      if (turn > 5) {
        console.log('All guesses USED');
        return;
      }

      if (history.includes(currentGuess)) {
        console.log('You already TRIED this word');
        return;
      }

      if (currentGuess.length !== solution.length) {
        console.log('Letter MISSING');
        return;
      }

      const formatted = formatGuess();
      console.log('FORMATTED', formatted);
      addNewGuess(formatted);
    }

    if (key === 'Backspace') {
      setCurrentGuess((prev) => {
        return prev.slice(0, -1);
      });
      return;
    }

    if (/^[A-Za-zÀ-ÖØ-öø-ÿ]$/.test(key)) {
      if (currentGuess.length < solution.length) {
        setCurrentGuess((prev) => {
          return prev + removeAccents(key);
        });
      }
    }
  };

  return { turn, currentGuess, guesses, isCorrect, handleKeyup };
};

export default useWordle;
